import React from "react"

interface IconButtonProps {
  children: React.ReactNode
  type?: "button" | "submit" | "reset"
  onClick?: () => void
  disabled?: boolean
  className?: string
  variant?: "subtle" | "ghost" | "danger"
  ariaLabel?: string
}

const VARIANT_CLASSNAME: Record<NonNullable<IconButtonProps["variant"]>, string> = {
  subtle: "text-slate-400 hover:bg-slate-100 hover:text-slate-500",
  ghost: "text-gray-400 hover:bg-gray-100 hover:text-gray-600",
  danger: "text-red-500 hover:bg-red-50 hover:text-red-600",
}

const IconButton: React.FC<IconButtonProps> = ({
  children,
  type = "button",
  onClick,
  disabled = false,
  className = "",
  variant = "ghost",
  ariaLabel,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`inline-flex items-center justify-center rounded-lg p-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASSNAME[variant]} ${className}`.trim()}
    >
      {children}
    </button>
  )
}

export default IconButton